/**
 * Thin wrapper around gtag for product events.
 *
 * index.html defines window.gtag in every environment but only configures and
 * fetches Analytics on a production host, so calling this from staging or
 * localhost queues a dataLayer entry and sends nothing. Callers therefore never
 * need to ask which environment they are in.
 *
 * NEVER pass anything that identifies a customer - no phone number, no ticket
 * code, no name. These events exist to show which parts of the product get
 * used, not who used them.
 *
 * Note for whoever reads the reports: GA4 shows event NAMES out of the box, but
 * the parameters below (ad_title, menu_title, placement, ...) only appear in
 * reports once they are registered as custom dimensions in GA4 Admin.
 */
export const trackEvent = (name, params = {}) => {
    try {
        if (typeof window === "undefined") return;
        if (typeof window.gtag !== "function") return;

        window.gtag("event", name, params);
    } catch (err) {
        // Analytics must never take the queue down with it.
        console.debug("analytics: could not record", name, err);
    }
};

export default trackEvent;
